import classNames from 'classnames';
import { autobind } from 'core-decorators';
import PropTypes from 'prop-types';
import { Component, Fragment } from 'react';
import Icon from '/@/components/icon';
import settings from '/@/core/settings';
import { _ } from '/@/locale';
import Input from '/@/v3/components/forms/input';
import Title from '/@/v3/components/title';
import WeedControl from '/@/views/recommendations/recommendation-detail/modules/weed-control';

import styles from './styles.module.css';

@autobind
export default class RecommendationWeedsPDF extends Component {
    static propTypes = {
        recommendation: PropTypes.object,
        language: PropTypes.string,
    };

    parseWeedSystem(weedSystem) {
        return `${_(weedSystem.secondaryCrop)} / ${_(weedSystem.mainCrop)}`;
    }

    renderModuleData(weedConfig) {
        return (
            <Fragment>
                <WeedControl
                    system={[weedConfig.weedSystem]}
                    weedControlPlan={weedConfig.controlPlan}
                    classNameWeedControl={styles.weedControl}
                />
            </Fragment>
        );
    }

    renderModuleCombination(weedConfig) {
        return (
            <div key={weedConfig.weed.id} className={styles.divider}>
                <div className={styles.containerCombination}>
                    <div className={styles.containerSubtitle}>
                        <Title className={styles.titleCombinations}>{_('Combinaciones posibles')}</Title>
                    </div>
                    <div className={styles.containerSelection}>
                        <div className={styles.titleSelect}>
                            <Title className={styles.subtitle}>{_('Sistema agrícola')}</Title>
                            <Input
                                value={this.parseWeedSystem(weedConfig.weedSystem)}
                                onChange={() => {}}
                                size='md'
                                color={settings.app.theme}
                                placeholder={_('Sistema agrícola')}
                                className={styles.selectWidth}
                            />
                        </div>
                        <div className={classNames(styles.titleSelect, styles.spaceTitleSelect)}>
                            <Title className={styles.subtitle}>{_('Maleza')}</Title>
                            <Input
                                value={_(weedConfig.weed.name)}
                                onChange={() => {}}
                                size='md'
                                color={settings.app.theme}
                                placeholder={_('Maleza')}
                                className={classNames(styles.selectWidth)}
                                addNoWrap={false}
                                ellipsis
                            />
                        </div>
                    </div>
                </div>
                {this.renderModuleData(weedConfig)}
            </div>
        );
    }

    render() {
        const { recommendation } = this.props;
        return (
            <div className={styles.root}>
                <div className={styles.container}>
                    <div className={styles.containerTitle}>
                        <Icon theme='weeds-pests' size='sm' type='weeds' container='circle' padding />
                        <Title className={styles.title}>{_('Manejo de Malezas')}</Title>
                    </div>
                    {recommendation.weeds.map((weedConfig) => this.renderModuleCombination(weedConfig))}
                </div>
                <div id={recommendation.id} style={{ float: 'left', clear: 'both' }} />
            </div>
        );
    }
}
